import React from "react"
import { Navigate, useSearchParams } from "react-router-dom"
import useLearnerAuth from "./useLearnerAuth"
import LearnerAuthBootScreen from "./LearnerAuthBootScreen"
import { LEARNER_DEFAULT_PATH } from "./constants"
import { resolveLearnerReturnPath } from "./errors"

interface RequireLearnerGuestProps {
  children: React.ReactNode
}

const RequireLearnerGuest = ({ children }: RequireLearnerGuestProps) => {
  const { isBooting, isAuthenticated } = useLearnerAuth()
  const [params] = useSearchParams()

  if (isBooting) {
    return <LearnerAuthBootScreen />
  }

  if (isAuthenticated) {
    const next = resolveLearnerReturnPath(params.get("next"), LEARNER_DEFAULT_PATH)
    return <Navigate to={next} replace />
  }

  return <>{children}</>
}

export default RequireLearnerGuest
